(function () {
  'use strict';

  var MIN_QTY = 1;
  var MAX_QTY = 1000;
  var REC_LIMIT = 10;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var drawer = document.getElementById('customCart');
    var tpl = document.getElementById('customCartItemTpl');
    var recTpl = document.getElementById('customCartRecTpl');
    if (!drawer || !tpl) return;

    var elItems = drawer.querySelector('[data-custom-cart-items]');
    var elEmpty = drawer.querySelector('[data-custom-cart-empty]');
    var elEmptyBar = drawer.querySelector('[data-custom-cart-empty-bar]');
    var elLoading = drawer.querySelector('[data-custom-cart-loading]');
    var elCount = drawer.querySelector('[data-custom-cart-count]');
    var elSubtotal = drawer.querySelector('[data-custom-cart-subtotal]');
    var elOriginal = drawer.querySelector('[data-custom-cart-original]');
    var elDiscountRow = drawer.querySelector('[data-custom-cart-discount-row]');
    var elDiscount = drawer.querySelector('[data-custom-cart-discount]');
    var elCheckout = drawer.querySelector('[data-custom-cart-checkout]');
    var elDiscountForm = drawer.querySelector('[data-custom-cart-discount-form]');
    var elDiscountInput = drawer.querySelector('[data-custom-cart-discount-input]');
    var elDiscountApply = drawer.querySelector('[data-custom-cart-discount-apply]');
    var elDiscountTags = drawer.querySelector('[data-custom-cart-discount-tags]');
    var elDiscountWrap = drawer.querySelector('[data-custom-cart-discount-wrap]');
    var elShippingBar = drawer.querySelector('[data-custom-cart-shipping-bar]');
    var elToast = drawer.querySelector('[data-custom-cart-toast]');
    var elToastIcon = drawer.querySelector('[data-custom-cart-toast-icon]');
    var elToastMessage = drawer.querySelector('[data-custom-cart-toast-message]');
    var elNoteWrap = drawer.querySelector('[data-custom-cart-note]');
    var elNoteToggle = drawer.querySelector('[data-custom-cart-note-toggle]');
    var elNoteInput = drawer.querySelector('[data-custom-cart-note-input]');
    var elNoteCheckoutHint = drawer.querySelector('[data-custom-cart-note-checkout-hint]');
    var elModal = drawer.querySelector('[data-custom-cart-modal]');
    var elModalTitle = drawer.querySelector('[data-custom-cart-modal-title]');
    var elModalText = drawer.querySelector('[data-custom-cart-modal-text]');
    var elRecommendations = drawer.querySelector('[data-custom-cart-recommendations]');
    var elRecommendationsList = drawer.querySelector('[data-custom-cart-recommendations-list]');
    var elQuickAdd = drawer.querySelector('[data-custom-cart-quick-add]');
    var elQAImage = drawer.querySelector('[data-custom-cart-quick-add-image]');
    var elQAImageLink = drawer.querySelector('[data-custom-cart-quick-add-image-link]');
    var elQATitle = drawer.querySelector('[data-custom-cart-quick-add-title]');
    var elQAMeta = drawer.querySelector('[data-custom-cart-quick-add-meta]');
    var elQAPriceFinal = drawer.querySelector('[data-custom-cart-quick-add-price-final]');
    var elQAPriceCompare = drawer.querySelector('[data-custom-cart-quick-add-price-compare]');
    var elQAOptions = drawer.querySelector('[data-custom-cart-quick-add-options]');
    var elQASubmit = drawer.querySelector('[data-custom-cart-quick-add-submit]');
    var elProtectionWrap = drawer.querySelector('.custom-cart__protection');
    var elProtectionPrice = drawer.querySelector('[data-custom-cart-protection-price]');
    var elProtectionToggle = drawer.querySelector('[data-custom-cart-protection]');
    var elBanner = drawer.querySelector('[data-custom-cart-banner]');

    var routes = (window.theme && window.theme.routes) || {};
    var cartUrl = routes.cart || '/cart.js';
    var changeUrl = routes.cartChange || '/cart/change.js';
    var addUrl = routes.cartAdd || '/cart/add.js';
    var updateUrl = '/cart/update.js';
    var moneyFormat = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';

    var discountInvalidMsg = drawer.dataset.discountInvalidMsg || '';
    var discountMinAmountMsg = drawer.dataset.discountMinAmountMsg || '';
    var discountNoEligibleItemsMsg = drawer.dataset.discountNoEligibleItemsMsg || '';
    var discountExpiredMsg = drawer.dataset.discountExpiredMsg || '';
    var discountNotStartedMsg = drawer.dataset.discountNotStartedMsg || '';
    var discountUsageLimitMsg = drawer.dataset.discountUsageLimitMsg || '';
    var discountCustomerLoginMsg = drawer.dataset.discountCustomerLoginMsg || '';
    var discountShippingCountryMsg = drawer.dataset.discountShippingCountryMsg || '';
    var noteOpenLabel = drawer.dataset.noteOpenLabel || '';
    var noteCloseLabel = drawer.dataset.noteCloseLabel || '';
    var soldOutLabel = drawer.dataset.soldOutLabel || '';
    var addToCartLabel = drawer.dataset.addToCartLabel || '';
    var qtyHtmlErrorMsg = drawer.dataset.qtyHtmlErrorMsg || '';
    var qtyClampConfirmMsg = drawer.dataset.qtyClampConfirmMsg || '';
    var qtyStockModalMsg = drawer.dataset.qtyStockModalMsg || '';
    var qtyStockLimitTitle = drawer.dataset.qtyStockLimitTitle || '';
    var addNetworkErrorTitle = drawer.dataset.addNetworkErrorTitle || '';
    var addNetworkErrorBody = drawer.dataset.addNetworkErrorBody || '';
    var discountAppliedToast = drawer.dataset.discountAppliedToast || '';
    var discountRemovedToast = drawer.dataset.discountRemovedToast || '';
    var removeDiscountAria = drawer.dataset.removeDiscountAria || 'Remove';
    var noteSaveFailedMsg = drawer.dataset.noteSaveFailed || '';
    var discountTagIconSrc = drawer.dataset.customCartDiscountIcon || '';
    var toastSuccessIconSrc = drawer.dataset.customCartToastIconSuccess || '';
    var toastErrorIconSrc = drawer.dataset.customCartToastIconError || '';

    function readCustomerSideCartProtectionConfig() {
      var pidRaw = drawer.getAttribute('data-protection-product-id');
      var vidRaw = drawer.getAttribute('data-protection-variant-id');
      var hdl = drawer.getAttribute('data-protection-product-handle');
      return {
        productId: parseInt(String(pidRaw == null ? '' : pidRaw).trim(), 10) || 0,
        variantId: parseInt(String(vidRaw == null ? '' : vidRaw).trim(), 10) || 0,
        handle: String(hdl == null ? '' : hdl).trim()
      };
    }

    var _protCfg = readCustomerSideCartProtectionConfig();
    var protectionProductId = _protCfg.productId;
    var protectionVariantId = _protCfg.variantId;
    var protectionProductHandle = _protCfg.handle || '';
    var protectionConfigResolved = false;
    var cachedProtectionUnitCents = 0;
    var cachedProtectionCompareCents = 0;

    function syncProtectionConfigFromDrawer() {
      var cfg = readCustomerSideCartProtectionConfig();
      if (cfg.productId) protectionProductId = cfg.productId;
      if (cfg.variantId) protectionVariantId = cfg.variantId;
      if (cfg.handle) protectionProductHandle = cfg.handle;
      if (!protectionVariantId && (protectionProductHandle || protectionProductId)) {
        protectionConfigResolved = false;
      } else if (protectionVariantId && cachedProtectionUnitCents <= 0) {
        protectionConfigResolved = false;
      }
    }

    function rememberProtectionVariantPrices(variant) {
      if (!variant) return;
      if (variant.price != null) cachedProtectionUnitCents = cents(variant.price);
      if (variant.compare_at_price != null) {
        cachedProtectionCompareCents = cents(variant.compare_at_price);
      }
    }

    function syncProtectionUnitCentsFromCache() {
      if (!protectionVariantId) return cachedProtectionUnitCents;
      if (Object.prototype.hasOwnProperty.call(variantCache, protectionVariantId)) {
        rememberProtectionVariantPrices(variantCache[protectionVariantId]);
      }
      return cachedProtectionUnitCents;
    }

    var SS_PROT_INTENT = 'customCartProtection_intent';
    var SS_PROT_CHECKOUT_RETURN = 'customCartProtection_checkoutReturn';

    function readProtectionPendingIntent() {
      try {
        var stored = window.sessionStorage.getItem(SS_PROT_INTENT);
        if (stored === '0') return false;
        return true;
      } catch (eIntent) {
        return true;
      }
    }

    function persistProtectionPendingIntent(enable) {
      try {
        window.sessionStorage.setItem(SS_PROT_INTENT, enable ? '1' : '0');
      } catch (ePersist) {}
    }

    var protectionPendingIntent = readProtectionPendingIntent();

    var lastRenderedCart = null;
    var lastRenderedItemRows = null;

    function isProtectionCartLine(item) {
      if (!item) return false;
      if (protectionProductId && Number(item.product_id) === Number(protectionProductId)) return true;
      if (protectionProductHandle && item.handle && String(item.handle) === String(protectionProductHandle)) return true;
      return false;
    }

    function isProtectionConfigured() {
      return drawer.getAttribute('data-protection-configured') === 'true';
    }

    function storefrontProductJsUrl(handleOrId) {
      var h = (handleOrId || '').trim();
      if (!h) return '';
      var base = routes.home != null ? String(routes.home) : '';
      if (!base || base === '') base = '/';
      if (base !== '/' && base.slice(-1) !== '/') base += '/';
      return base + 'products/' + encodeURIComponent(h) + '.js';
    }

    function storefrontProductsByIdsUrl(numericId) {
      var base = routes.home != null ? String(routes.home) : '';
      if (!base || base === '') base = '/';
      if (base !== '/' && base.slice(-1) !== '/') base += '/';
      return base + 'products.json?ids=' + encodeURIComponent(numericId) + '&limit=1';
    }

    function applyProtectionProductFromStorefront(prod) {
      if (!prod || prod.id == null) return;
      var variants = prod.variants || [];
      var v =
        variants.find(function (x) { return x && x.available; }) || variants[0];
      if (!v || v.id == null) return;
      protectionProductId = Number(prod.id) || protectionProductId;
      protectionVariantId = Number(v.id) || protectionVariantId;
      rememberProtectionVariantPrices(v);
      if (!protectionProductHandle && prod.handle) {
        protectionProductHandle = String(prod.handle).trim();
      }
    }

    function refreshProtectionUIAfterResolve() {
      if (!lastRenderedCart) return;
      var cartEmpty = !lastRenderedCart.items || !lastRenderedCart.items.length;
      var protInfo = getProtectionLineInfo(lastRenderedCart);
      updateProtectionUI(protInfo.inCart, protInfo.unitCents, cartEmpty);
    }

    function resolveProtectionConfig() {
      if (!isProtectionConfigured()) {
        protectionConfigResolved = true;
        return Promise.resolve();
      }

      if (protectionConfigResolved && protectionVariantId && cachedProtectionUnitCents > 0) {
        return Promise.resolve();
      }

      var fetchPromise = null;
      var handle = (protectionProductHandle || '').trim();

      if (handle && !/^\d+$/.test(handle)) {
        fetchPromise = fetchJSON(storefrontProductJsUrl(handle)).then(function (prod) {
          applyProtectionProductFromStorefront(prod);
        });
      } else if (protectionProductId) {
        fetchPromise = fetchJSON(storefrontProductsByIdsUrl(String(protectionProductId))).then(function (data) {
          var prods = (data && data.products) || [];
          applyProtectionProductFromStorefront(prods[0] || null);
        });
      } else if (handle && /^\d+$/.test(handle)) {
        fetchPromise = fetchJSON(storefrontProductsByIdsUrl(handle)).then(function (data) {
          var prods = (data && data.products) || [];
          applyProtectionProductFromStorefront(prods[0] || null);
        });
      }

      if (!fetchPromise) {
        protectionConfigResolved = true;
        return Promise.resolve();
      }

      return fetchPromise
        .catch(function () {})
        .finally(function () {
          protectionConfigResolved = true;
          refreshProtectionUIAfterResolve();
        });
    }

    function removeProtectionLinesFromCart() {
      if (!isProtectionConfigured()) return Promise.resolve();
      return fetchJSON(cartUrl).then(function (cart) {
        var keys = [];
        (cart.items || []).forEach(function (item) {
          if (!isProtectionCartLine(item)) return;
          var k = item.key != null ? String(item.key).trim() : '';
          if (k) keys.push(k);
        });
        if (!keys.length) return Promise.resolve();
        return keys.reduce(function (acc, key) {
          return acc.then(function () {
            return fetchJSON(changeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        }, Promise.resolve());
      });
    }

    function maybeRemoveOrphanProtection(cart) {
      if (!isProtectionConfigured() || !cart || !cart.items || !cart.items.length) {
        return Promise.resolve(cart);
      }
      var hasProt = cart.items.some(isProtectionCartLine);
      if (!hasProt) return Promise.resolve(cart);
      return removeProtectionLinesFromCart()
        .then(function () {
          return fetchJSON(cartUrl);
        })
        .catch(function () {
          return cart;
        });
    }

    function ensureProtectionRemovedForDiscount() {
      if (!isProtectionConfigured()) return Promise.resolve();
      return removeProtectionLinesFromCart().catch(function () {});
    }

    function getProtectionLineInfo(cart) {
      var info = { inCart: false, lineCents: 0, unitCents: 0 };
      if (!isProtectionConfigured() || !cart || !cart.items) return info;
      cart.items.forEach(function (item) {
        if (!isProtectionCartLine(item)) return;
        info.inCart = true;
        info.unitCents = cents(item.final_price);
        info.lineCents = item.final_line_price != null
          ? cents(item.final_line_price)
          : info.unitCents * (item.quantity || 1);
      });
      return info;
    }

    function resolvePendingProtectionUnitCents() {
      syncProtectionUnitCentsFromCache();
      if (cachedProtectionUnitCents > 0) return Promise.resolve(cachedProtectionUnitCents);
      if (!protectionVariantId) return Promise.resolve(0);
      return fetchVariantCached(protectionVariantId).then(function (v) {
        rememberProtectionVariantPrices(v);
        return cachedProtectionUnitCents;
      });
    }

    function computeSubtotalDisplayCentsSync(cart) {
      var base = cents(cart && cart.total_price);
      if (!isProtectionConfigured() || !cart) return base;
      var prot = getProtectionLineInfo(cart);
      if (prot.inCart) {
        if (protectionPendingIntent) return base;
        return Math.max(0, base - prot.lineCents);
      }
      if (protectionPendingIntent) {
        return base + syncProtectionUnitCentsFromCache();
      }
      return base;
    }

    function computeCompareSubtotalForDisplay(cart, itemRows) {
      var originalSum = computeCompareSubtotalCentsFromRows(cart, itemRows);
      var prot = getProtectionLineInfo(cart);
      if (prot.inCart || !protectionPendingIntent || !isProtectionConfigured()) {
        return originalSum;
      }
      var unit = syncProtectionUnitCentsFromCache();
      if (unit <= 0) return originalSum;
      if (cachedProtectionCompareCents > unit) originalSum += cachedProtectionCompareCents;
      else originalSum += unit;
      return originalSum;
    }

    function updateCartTotalsDisplaySync(cart, itemRows) {
      if (!cart || !elSubtotal) return;
      var rows = itemRows || lastRenderedItemRows || [];
      var displaySubtotal = computeSubtotalDisplayCentsSync(cart);
      elSubtotal.innerHTML = money(displaySubtotal);
      updateSubtotalStrikethroughFromRows(cart, rows, displaySubtotal);
      if (rows.length) updateDiscountRowDisplay(cart, rows, displaySubtotal);
    }

    function markCheckoutReturnStrip() {
      try {
        window.sessionStorage.setItem(SS_PROT_CHECKOUT_RETURN, '1');
      } catch (eStrip) {}
    }

    var pendingModalAction = null;
    var toastTimer = null;
    var currentQuickAddProduct = null;
    var currentQuickAddVariant = null;
    var lastRecommendedFor = null;
    var variantCache = {};
    var refreshGeneration = 0;
    var applyingDiscount = false;
    var removingDiscount = false;
    var discountApplySafetyTimer = null;

    function resetDiscountApplyUi() {
      applyingDiscount = false;
      if (discountApplySafetyTimer) {
        clearTimeout(discountApplySafetyTimer);
        discountApplySafetyTimer = null;
      }
      if (elDiscountApply) {
        elDiscountApply.disabled = false;
        elDiscountApply.classList.remove('is-applying');
      }
    }

    function beginDiscountApplyUi(timeoutMs) {
      applyingDiscount = true;
      if (elDiscountApply) {
        elDiscountApply.disabled = true;
        elDiscountApply.classList.add('is-applying');
      }
      if (discountApplySafetyTimer) clearTimeout(discountApplySafetyTimer);
      discountApplySafetyTimer = setTimeout(function () {
        discountApplySafetyTimer = null;
        if (!applyingDiscount) return;
        applyingDiscount = false;
        if (elDiscountApply) {
          elDiscountApply.disabled = false;
          elDiscountApply.classList.remove('is-applying');
        }
      }, timeoutMs == null ? 20000 : timeoutMs);
    }
    var activeLoadingGen = null;
    var cartCloseAnimTimer = null;
    var lastCartOpenTrigger = null;
    var cartFetchInflight = null;
    var recommendationsLoadToken = 0;
    var cartOpenUiReady = false;

    function cents(v) {
      if (v == null || v === '') return 0;
      var n = typeof v === 'string' ? parseFloat(v) : Number(v);
      if (isNaN(n) || n < 0) return 0;
      return Math.round(n);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return intPart + decPart;
    }

    function money(cents) {
      if (cents == null) cents = 0;
      var value = '';
      var fmt = moneyFormat || '${{amount}}';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var match = fmt.match(placeholderRegex);
      if (!match) return fmt + (cents / 100).toFixed(2);
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
      return fmt.replace(placeholderRegex, value);
    }

    function shopMoneyFieldToCents(raw) {
      if (raw == null || raw === '') return 0;
      if (typeof raw === 'string') {
        var t = String(raw).trim().replace(',', '.');
        if (!t) return 0;
        if (t.indexOf('.') !== -1) {
          var dec = parseFloat(t, 10);
          return isNaN(dec) ? 0 : Math.round(dec * 100);
        }
        var whole = parseInt(t, 10);
        return isNaN(whole) ? 0 : whole;
      }
      var n = Number(raw);
      if (isNaN(n)) return 0;
      if (n % 1 !== 0) return Math.round(n * 100);
      return Math.round(n);
    }

    function recProductPriceCents(p) {
      var v0 = p.variants && p.variants[0];
      var raw = p.price_min;
      if (raw == null || raw === '') raw = p.price;
      if ((raw == null || raw === '') && v0) raw = v0.price;
      return shopMoneyFieldToCents(raw);
    }

    function recProductCompareCents(p) {
      var v0 = p.variants && p.variants[0];
      var raw = p.compare_at_price_min;
      if (raw == null || raw === '') raw = p.compare_at_price;
      if ((raw == null || raw === '') && v0) raw = v0.compare_at_price;
      return shopMoneyFieldToCents(raw);
    }

    function moneyPlain(cents) {
      var s = money(cents);
      if (s == null) return '';
      s = String(s);
      if (s.indexOf('<') === -1) return s;
      var div = document.createElement('div');
      div.innerHTML = s;
      var plain = (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
      return plain || s.replace(/<[^>]*>/g, '').trim();
    }

    function discountAmountCents(cart) {
      if (!cart) return 0;
      var td = Number(cart.total_discount);
      if (!isNaN(td) && td > 0) return Math.round(td);
      var sumOrig = 0;
      (cart.items || []).forEach(function (it) {
        var o = it.original_line_price;
        var f = it.final_line_price;
        if (o != null && f != null && Number(o) > Number(f)) {
          sumOrig += Number(o) - Number(f);
        }
      });
      if (sumOrig > 0) return Math.round(sumOrig);
      var sumAlloc = 0;
      (cart.items || []).forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (al) {
          sumAlloc += Number(al.amount || 0);
        });
      });
      return Math.round(sumAlloc);
    }

    function cartMerchandiseSubtotalCents(cart) {
      if (!cart) return 0;
      if (cart.items_subtotal_price != null && cart.items_subtotal_price !== '') {
        return Math.round(Number(cart.items_subtotal_price));
      }
      var t = 0;
      (cart.items || []).forEach(function (it) {
        if (it.final_line_price != null) {
          t += Number(it.final_line_price);
        } else if (it.final_price != null && it.quantity != null) {
          t += Number(it.final_price) * Number(it.quantity);
        }
      });
      return Math.round(t);
    }

    function cartMerchandiseSubtotalExcludingProtectionCents(cart) {
      if (!cart) return 0;
      var total = 0;
      (cart.items || []).forEach(function (it) {
        if (isProtectionCartLine(it)) return;
        if (it.final_line_price != null) {
          total += Number(it.final_line_price);
        } else if (it.final_price != null && it.quantity != null) {
          total += Number(it.final_price) * Number(it.quantity);
        }
      });
      return Math.round(total);
    }

    function updateShippingBar(cart) {
      if (!elShippingBar || !drawer) return;
      if (drawer.dataset.shippingBar !== 'true') {
        elShippingBar.hidden = true;
        return;
      }
      var maxC = parseInt(drawer.dataset.shippingBarMaxCents, 10);
      if (!maxC || maxC <= 0 || isNaN(maxC)) {
        elShippingBar.hidden = true;
        return;
      }
      var segments = parseInt(drawer.dataset.shippingBarSegments, 10);
      if (isNaN(segments) || segments < 2) segments = 4;

      var merch = cartMerchandiseSubtotalExcludingProtectionCents(cart);
      var progress = maxC > 0 ? Math.min(100, (merch / maxC) * 100) : 0;

      var msgEl = elShippingBar.querySelector('[data-custom-cart-shipping-bar-message]');
      var ticksEl = elShippingBar.querySelector('[data-custom-cart-shipping-bar-ticks]');
      var labelsEl = elShippingBar.querySelector('[data-custom-cart-shipping-bar-labels]');

      var before = drawer.dataset.shippingBarTextBefore || '';
      var after = drawer.dataset.shippingBarTextAfter || '';

      if (msgEl) {
        if (merch >= maxC) {
          msgEl.textContent = after || '';
        } else {
          var remaining = Math.max(0, maxC - merch);
          msgEl.textContent = before ? before.split('[[remaining]]').join(moneyPlain(remaining)) : '';
        }
      }
      elShippingBar.style.setProperty('--shipping-progress', String(progress));

      if (labelsEl && ticksEl) {
        var sig = maxC + ':' + segments;
        if (labelsEl.dataset.sig !== sig) {
          labelsEl.innerHTML = '';
          ticksEl.innerHTML = '';
          labelsEl.dataset.sig = sig;
          ticksEl.dataset.sig = sig;
          var i;
          for (i = 0; i <= segments; i++) {
            var span = document.createElement('span');
            span.className = 'custom-cart__shipping-bar-label';
            span.textContent = moneyPlain(Math.round((maxC * i) / segments));
            var frac = segments > 0 ? i / segments : 0;
            var leftCss = 'calc(6px + (100% - 12px) * ' + frac + ')';
            span.style.left = leftCss;
            labelsEl.appendChild(span);
            var tick = document.createElement('span');
            tick.className = 'custom-cart__shipping-bar-tick';
            tick.setAttribute('aria-hidden', 'true');
            tick.style.left = leftCss;
            ticksEl.appendChild(tick);
          }
        }
      }

      elShippingBar.hidden = false;
    }

    function resizedImage(url, size) {
      if (!url) return '';
      return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + '$1$3');
    }

    function isLikelyNetworkError(err) {
      if (!err) return false;
      if (err.status != null && err.status !== 0) return false;
      var name = String(err.name || '');
      if (name === 'TypeError' || name === 'AbortError') return true;
      var msg = String(err.message || '').toLowerCase();
      if (msg.indexOf('failed to fetch') !== -1) return true;
      if (msg.indexOf('networkerror') !== -1) return true;
      if (msg.indexOf('load failed') !== -1) return true;
      if (msg.indexOf('network request failed') !== -1) return true;
      return false;
    }

    function setCartEmptyState(isEmpty) {
      var empty = !!isEmpty;
      drawer.classList.toggle('custom-cart--empty', empty);
      if (elEmptyBar) elEmptyBar.hidden = !empty;
    }

    function showModal(msg, titleText) {
      if (!elModal) return;
      if (elModalTitle) {
        if (titleText && String(titleText).trim()) {
          elModalTitle.textContent = String(titleText).trim();
          elModalTitle.hidden = false;
        } else {
          elModalTitle.textContent = '';
          elModalTitle.hidden = true;
        }
      }
      elModalText.textContent = msg || '';
      elModal.hidden = false;
    }

    function showCartErrorModal(body, titleText) {
      var title = String(titleText || '').trim();
      if (!title) title = String(qtyStockLimitTitle || '').trim();
      if (!title) title = String(qtyHtmlErrorMsg || '').trim() || 'Error';
      showModal(String(body || '').trim(), title);
    }

    function hideModal() {
      if (!elModal) return;
      elModal.hidden = true;
      if (elModalTitle) {
        elModalTitle.textContent = '';
        elModalTitle.hidden = true;
      }
      if (elModalText) elModalText.textContent = '';
    }

    function parseAvailableQtyFromMessage(msg) {
      if (!msg || typeof msg !== 'string') return null;
      var patterns = [
        /Only\s+(\d+)\s+items?\s+were\s+added/i,
        /There are only\s+(\d+)/i,
        /only\s+(\d+)\s+of/i,
        /only\s+(\d+)/i,
        /(\d+)\s+are\s+available/i,
        /(\d+)\s+available/i,
        /quantity.*?(\d+)/i,
        /(\d+)\s*件/i,
        /最多\s*(\d+)/i
      ];
      for (var pi = 0; pi < patterns.length; pi++) {
        var m = msg.match(patterns[pi]);
        if (m) return Math.max(0, parseInt(m[1], 10));
      }
      return null;
    }

    function resolveClampMeta(lineKey) {
      return fetchJSON(cartUrl).then(function (cart) {
        var items = cart.items || [];
        var item = null;
        for (var ii = 0; ii < items.length; ii++) {
          if (items[ii].key === lineKey) {
            item = items[ii];
            break;
          }
        }
        var lineTitle = item ? (item.product_title || item.title || '') : '';
        if (!item) return { clamp: null, lineTitle: lineTitle };
        return fetchVariantCached(item.variant_id).then(function (v) {
          var clamp = null;
          if (v && v.inventory_management != null && v.inventory_quantity != null && !isNaN(Number(v.inventory_quantity))) {
            clamp = Math.max(0, parseInt(v.inventory_quantity, 10));
          }
          return { clamp: clamp, lineTitle: lineTitle };
        });
      }).catch(function () {
        return { clamp: null, lineTitle: '' };
      });
    }

    function normalizeErrorDescription(d) {
      if (d == null || d === '') return '';
      if (typeof d === 'string') return d;
      if (typeof d === 'object') {
        if (Array.isArray(d)) return d.map(normalizeErrorDescription).filter(Boolean).join(' ');
        if (d.base && Array.isArray(d.base)) return d.base.map(String).join(' ');
        if (d.quantity != null) return String(d.quantity);
        try {
          return JSON.stringify(d);
        } catch (e) {
          return String(d);
        }
      }
      return String(d);
    }

    function buildQtyErrorModalText(err, clampQty, lineTitle) {
      if (clampQty != null && qtyStockModalMsg) {
        return qtyStockModalMsg.split('[[max]]').join(String(clampQty)).split('[[title]]').join(lineTitle || '');
      }
      var fromData = normalizeErrorDescription(err.data && err.data.description);
      if (!fromData) fromData = normalizeErrorDescription(err.data && err.data.message);
      var head = fromData || err.message || '';
      if (err.isHtml || (!fromData && (err.bodyText || '').trim().charAt(0) === '<')) {
        head = qtyHtmlErrorMsg || head || 'Error';
      }
      if (!head) head = qtyHtmlErrorMsg || 'Error';
      if (clampQty != null && qtyClampConfirmMsg) {
        var tail = qtyClampConfirmMsg.split('[[max]]').join(String(clampQty));
        return tail ? head + '\n\n' + tail : head;
      }
      return head;
    }

    function hideToast() {
      if (!elToast) return;
      clearTimeout(toastTimer);
      elToast.hidden = true;
      elToast.removeAttribute('data-state');
      if (elToastMessage) elToastMessage.textContent = '';
      if (elToastIcon) elToastIcon.innerHTML = '';
    }

    function isMobileDevice() {
      if (window.matchMedia) {
        var coarse = window.matchMedia('(pointer: coarse)').matches;
        var narrow = window.matchMedia('(max-width: 749px)').matches;
        if (coarse && narrow) return true;
      }
      return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || '');
    }

    function getMobileOs() {
      var ua = navigator.userAgent || '';
      if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
      if (/Android/i.test(ua)) return 'android';
      return 'other';
    }

    function getBannerDownloadUrl() {
      if (!elBanner) return '';
      var pc = (elBanner.dataset.bannerLinkPc || '').trim();
      var ios = (elBanner.dataset.bannerLinkIos || '').trim();
      var android = (elBanner.dataset.bannerLinkAndroid || '').trim();
      var mobile = (elBanner.dataset.bannerLinkMobile || '').trim();
      if (!isMobileDevice()) {
        return pc || mobile || ios || android;
      }
      var os = getMobileOs();
      if (os === 'ios') return ios || mobile || android || pc;
      if (os === 'android') return android || mobile || ios || pc;
      return mobile || android || ios || pc;
    }

    function handleBannerClick() {
      if (!elBanner) return;
      var url = getBannerDownloadUrl();
      if (!url) return;
      window.open(url, '_blank', 'noopener,noreferrer');
    }

    function showToast(type, text) {
      if (!elToast || !elToastMessage || !elToastIcon) return;
      clearTimeout(toastTimer);
      if (!text) {
        hideToast();
        return;
      }
      elToast.hidden = false;
      elToast.setAttribute('data-state', type === 'error' ? 'error' : 'success');
      elToastIcon.innerHTML = '';
      var iconSrc = type === 'error' ? toastErrorIconSrc : toastSuccessIconSrc;
      if (iconSrc) {
        var toastImg = document.createElement('img');
        toastImg.className = 'custom-cart__toast-icon-img';
        toastImg.src = iconSrc;
        toastImg.alt = '';
        toastImg.width = 20;
        toastImg.height = 20;
        elToastIcon.appendChild(toastImg);
      }
      elToastMessage.textContent = text;
      toastTimer = setTimeout(function () {
        hideToast();
      }, 4500);
    }

    function waitMs(ms) {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, ms);
      });
    }

    function normalizeDiscountCode(value) {
      return String(value || '').trim().toUpperCase();
    }

    function findDiscountCodeEntry(cart, typedCode) {
      var norm = normalizeDiscountCode(typedCode);
      if (!cart || !norm) return null;
      var dcs = cart.discount_codes || [];
      var i;
      var dc;
      for (i = 0; i < dcs.length; i++) {
        dc = dcs[i];
        if (!dc) continue;
        if (normalizeDiscountCode(dc.code) !== norm) continue;
        return dc;
      }
      return null;
    }

    function discountCodeHasCartEffect(cart, typedCode) {
      var norm = normalizeDiscountCode(typedCode);
      if (!cart || !norm) return false;

      var apps = cart.cart_level_discount_applications || [];
      var i;
      for (i = 0; i < apps.length; i++) {
        var app = apps[i];
        if (app && normalizeDiscountCode(app.title) === norm) return true;
      }

      var items = cart.items || [];
      for (i = 0; i < items.length; i++) {
        var item = items[i];
        var allocs = item.line_level_discount_allocations || [];
        var j;
        for (j = 0; j < allocs.length; j++) {
          var alloc = allocs[j];
          var disc = alloc && alloc.discount_application;
          if (disc && normalizeDiscountCode(disc.title) === norm) return true;
        }
        var legacyDiscounts = item.discounts || [];
        for (j = 0; j < legacyDiscounts.length; j++) {
          var legacy = legacyDiscounts[j];
          if (legacy && normalizeDiscountCode(legacy.title) === norm) return true;
        }
      }

      return false;
    }

    function discountCodeIsApplicable(cart, typedCode) {
      var dc = findDiscountCodeEntry(cart, typedCode);
      if (!dc) return false;
      if (dc.applicable === false) return false;
      if (discountCodeHasCartEffect(cart, typedCode)) return true;
      // Free shipping and other checkout-only codes can be applicable without cart/line allocations.
      return dc.applicable === true;
    }

    function discountCodeIsActiveInCart(cart, typedCode) {
      var dc = findDiscountCodeEntry(cart, typedCode);
      return !!(dc && dc.applicable === true);
    }

    function cartShouldClearDiscountCodes(cart) {
      return ((cart && cart.discount_codes) || []).some(function (dc) {
        return dc && String(dc.code || '').trim() && dc.applicable === false;
      });
    }

    function prepareCartForDiscountEvaluation() {
      return ensureProtectionRemovedForDiscount().then(function () {
        return fetchCartJSON();
      });
    }

    function collectDiscountTagEntries(cart) {
      var entries = [];
      var seen = {};

      ((cart && cart.discount_codes) || []).forEach(function (dc) {
        if (!dc || !discountCodeIsActiveInCart(cart, dc.code)) return;
        var code = String(dc.code || '').trim();
        if (!code) return;
        var key = code.toUpperCase();
        if (seen[key]) return;
        seen[key] = true;
        entries.push({ label: code, code: code });
      });

      return entries;
    }

    function clearDiscountTagsUI() {
      if (!elDiscountTags) return;
      elDiscountTags.innerHTML = '';
      elDiscountTags.hidden = true;
    }

    function appendDiscountTagPill(labelText) {
      var pill = document.createElement('span');
      pill.className = 'custom-cart__discount-tag';

      if (discountTagIconSrc) {
        var iconImg = document.createElement('img');
        iconImg.className = 'custom-cart__discount-tag-icon';
        iconImg.src = discountTagIconSrc;
        iconImg.alt = '';
        iconImg.width = 16;
        iconImg.height = 16;
        pill.appendChild(iconImg);
      }

      var labelSpan = document.createElement('span');
      labelSpan.className = 'custom-cart__discount-tag-text';
      labelSpan.textContent = labelText;
      pill.appendChild(labelSpan);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-cart__discount-tag-remove';
      btn.setAttribute('data-custom-cart-discount-remove', '');
      btn.setAttribute('aria-label', removeDiscountAria);
      btn.textContent = '\u00D7';
      pill.appendChild(btn);
      elDiscountTags.appendChild(pill);
    }

    function updateDiscountTags(cart) {
      if (!elDiscountTags) return;
      elDiscountTags.innerHTML = '';
      var entries = collectDiscountTagEntries(cart);
      if (!entries.length) {
        elDiscountTags.hidden = true;
        return;
      }
      elDiscountTags.hidden = false;
      entries.forEach(function (entry) {
        appendDiscountTagPill(entry.label);
      });
    }

    function stripInjectedLineDiscounts() {
      if (!elItems) return;
      elItems.querySelectorAll('.custom-cart__item .cart__discount').forEach(function (n) {
        if (n.parentNode) n.parentNode.removeChild(n);
      });
    }

    function closeThemeCartDrawerIfOpen() {
      var cartDrawer = document.getElementById('CartDrawer');
      if (cartDrawer && cartDrawer.classList.contains('drawer--is-open')) {
        var closer = cartDrawer.querySelector('.js-drawer-close');
        if (closer) closer.click();
        else {
          cartDrawer.classList.remove('drawer--is-open');
          document.documentElement.classList.remove('js-drawer-open');
        }
      }
    }

    function setDiscountTagsRemoving(isRemoving) {
      if (!elDiscountTags) return;
      elDiscountTags.querySelectorAll('[data-custom-cart-discount-remove]').forEach(function (btn) {
        btn.disabled = isRemoving;
        btn.classList.toggle('is-removing', isRemoving);
      });
    }

    function removeCartDiscountCodes() {
      if (removingDiscount) return Promise.resolve(false);
      removingDiscount = true;
      setDiscountTagsRemoving(true);
      return postCartDiscount({ discount: '' })
        .then(function () {
          return refresh({ skipLoading: true });
        })
        .then(function () {
          return true;
        })
        .catch(function () {
          return false;
        })
        .finally(function () {
          removingDiscount = false;
          setDiscountTagsRemoving(false);
        });
    }

    function setQuickChatVisible(isVisible) {
      var api = window.quickChatApi;
      var method = isVisible ? 'open' : 'close';
      if (!api || typeof api[method] !== 'function') return;
      try {
        api[method]();
      } catch (err) {}
    }

    function open() {
      if (cartCloseAnimTimer) {
        clearTimeout(cartCloseAnimTimer);
        cartCloseAnimTimer = null;
      }
      syncProtectionConfigFromDrawer();
      drawer.classList.remove('is-closing');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('custom-cart-open');
      setQuickChatVisible(false);
      var hasCachedCart = !!(lastRenderedCart && lastRenderedCart.items);
      var openGen = ++refreshGeneration;
      resolveProtectionConfig()
        .catch(function () {})
        .then(function () {
          syncProtectionConfigFromDrawer();
          if (hasCachedCart) {
            return render(lastRenderedCart, openGen, {
              allowPatch: true,
              skipRecommendations: true
            });
          }
        })
        .finally(function () {
          refresh({ skipLoading: hasCachedCart });
        });
    }

    function releaseCartDrawerFocus() {
      var active = document.activeElement;
      if (!active || !drawer.contains(active)) return;
      var restore = lastCartOpenTrigger;
      lastCartOpenTrigger = null;
      if (restore && document.contains(restore) && typeof restore.focus === 'function') {
        try {
          restore.focus({ preventScroll: true });
        } catch (focusErr) {
          restore.focus();
        }
        return;
      }
      active.blur();
    }

    function finishCartCloseCleanup() {
      releaseCartDrawerFocus();
      drawer.classList.remove('is-open', 'is-closing');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('custom-cart-open');
      pendingModalAction = null;
      hideToast();
      hideModal();
      closeQuickAdd();
      setQuickChatVisible(true);
    }

    function close() {
      if (drawer.classList.contains('is-closing')) {
        return;
      }
      if (!drawer.classList.contains('is-open')) {
        pendingModalAction = null;
        hideToast();
        hideModal();
        closeQuickAdd();
        return;
      }
      var panel = drawer.querySelector('.custom-cart__panel');
      if (!panel) {
        finishCartCloseCleanup();
        return;
      }
      function done() {
        if (cartCloseAnimTimer) {
          clearTimeout(cartCloseAnimTimer);
          cartCloseAnimTimer = null;
        }
        panel.removeEventListener('transitionend', onPanelTransitionEnd);
        finishCartCloseCleanup();
      }
      function onPanelTransitionEnd(e) {
        if (e.target !== panel) return;
        if (e.propertyName !== 'transform') return;
        done();
      }
      panel.addEventListener('transitionend', onPanelTransitionEnd);
      releaseCartDrawerFocus();
      drawer.classList.add('is-closing');
      cartCloseAnimTimer = window.setTimeout(function () {
        cartCloseAnimTimer = null;
        if (drawer.classList.contains('is-closing')) {
          done();
        }
      }, 450);
    }

    function fetchJSON(url, options) {
      options = options || {};
      options.credentials = options.credentials || 'same-origin';
      options.mode = options.mode || 'same-origin';
      options.headers = Object.assign(
        {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        options.headers || {}
      );
      return fetch(url, options).then(function (r) {
        return r.text().then(function (text) {
          var trimmed = (text || '').trim();
          var data = null;
          if (trimmed && trimmed.charAt(0) !== '<') {
            try {
              data = JSON.parse(text);
            } catch (parseErr) {
              data = null;
            }
          }
          if (!r.ok) {
            var msg = (data && (data.description || data.message)) || '';
            if (!msg && trimmed.indexOf('<!DOCTYPE') !== -1) msg = qtyHtmlErrorMsg;
            if (!msg && trimmed.charAt(0) === '<') msg = qtyHtmlErrorMsg;
            if (!msg) msg = 'HTTP ' + r.status;
            var err = new Error(msg);
            err.data = data;
            err.status = r.status;
            err.bodyText = text;
            err.isHtml = !data && trimmed.charAt(0) === '<';
            throw err;
          }
          if (data == null) {
            if (!trimmed) return {};
            if (trimmed.charAt(0) === '<') {
              var errHtml = new Error(qtyHtmlErrorMsg || 'Invalid response');
              errHtml.isHtml = true;
              errHtml.bodyText = text;
              throw errHtml;
            }
            try {
              return JSON.parse(text);
            } catch (e2) {
              var errBad = new Error('Invalid response');
              errBad.bodyText = text;
              throw errBad;
            }
          }
          return data;
        });
      });
    }

    function invalidateCartFetchCache() {
      cartFetchInflight = null;
    }

    function fetchCartJSON(forceFresh) {
      if (!forceFresh && cartFetchInflight) return cartFetchInflight;
      var url = cartUrl;
      if (forceFresh) {
        url += (cartUrl.indexOf('?') >= 0 ? '&' : '?') + '_=' + Date.now();
      }
      var request = fetchJSON(url)
        .catch(function (err) {
          throw err;
        })
        .finally(function () {
          if (cartFetchInflight === request) {
            cartFetchInflight = null;
          }
        });
      if (!forceFresh) {
        cartFetchInflight = request;
      }
      return request;
    }

    function scheduleDeferred(fn) {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(function () {
          fn();
        }, { timeout: 1500 });
        return;
      }
      window.setTimeout(fn, 80);
    }

    function refresh(opts) {
      opts = opts || {};
      var myGen = ++refreshGeneration;
      var showSpinner = !opts.skipLoading;
      if (showSpinner && elLoading) {
        activeLoadingGen = myGen;
        elLoading.hidden = false;
      }
      if (opts.invalidateCache !== false) {
        invalidateCartFetchCache();
      }
      return resolveProtectionConfig()
        .then(function () {
          syncProtectionConfigFromDrawer();
          return fetchCartJSON(!!opts.forceFresh);
        })
        .then(function (cart) {
          return maybeRemoveOrphanProtection(cart);
        })
        .then(function (cart) {
          return sanitizeCartDiscountState(cart);
        })
        .then(function (cart) {
          if (myGen !== refreshGeneration) return Promise.resolve();
          return Promise.resolve(render(cart, myGen, opts));
        })
        .catch(function () {})
        .finally(function () {
          if (elLoading && activeLoadingGen === myGen) {
            elLoading.hidden = true;
            activeLoadingGen = null;
          }
        });
    }

    function fetchVariantCached(id) {
      if (!id) return Promise.resolve(null);
      if (Object.prototype.hasOwnProperty.call(variantCache, id)) {
        return Promise.resolve(variantCache[id]);
      }
      return fetchJSON('/variants/' + encodeURIComponent(id) + '.js')
        .then(function (v) {
          variantCache[id] = v;
          if (protectionVariantId && Number(id) === Number(protectionVariantId)) {
            rememberProtectionVariantPrices(v);
          }
          return v;
        })
        .catch(function () {
          variantCache[id] = null;
          return null;
        });
    }

    function prefetchVariantIdsBatched(ids, concurrency) {
      concurrency = Math.max(1, concurrency || 10);
      if (!ids || !ids.length) return Promise.resolve();
      var i = 0;
      function runWave() {
        if (i >= ids.length) return Promise.resolve();
        var wave = [];
        for (var w = 0; w < concurrency && i < ids.length; w++, i++) {
          wave.push(fetchVariantCached(ids[i]));
        }
        return Promise.all(wave).then(runWave);
      }
      return runWave();
    }

    function getUncachedVariantIds(ids) {
      if (!ids || !ids.length) return [];
      return ids.filter(function (id) {
        return id && !Object.prototype.hasOwnProperty.call(variantCache, id);
      });
    }

    function canPatchCartItems(cart, itemRows) {
      if (!cart || !itemRows || !itemRows.length) return false;
      var items = cart.items || [];
      if (items.length !== itemRows.length) return false;
      var i;
      for (i = 0; i < items.length; i++) {
        var key = items[i].key != null ? String(items[i].key) : '';
        var rowKey = itemRows[i].item.key != null ? String(itemRows[i].item.key) : '';
        if (key !== rowKey) return false;
        if (Number(items[i].variant_id) !== Number(itemRows[i].item.variant_id)) return false;
      }
      return true;
    }

    function populateCartItemNode(node, item) {
      var lineKey = item.key != null ? String(item.key).trim() : '';
      if (lineKey) {
        node.setAttribute('data-key', lineKey);
      } else {
        node.removeAttribute('data-key');
      }
      if (isProtectionCartLine(item)) {
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
        node.style.display = 'none';
      } else {
        node.hidden = false;
        node.removeAttribute('aria-hidden');
        node.style.display = '';
      }

      var imgWrap = node.querySelector('.custom-cart__item-image');
      var img = node.querySelector('.custom-cart__item-image img');
      imgWrap.href = item.url || '#';
      if (item.featured_image && item.featured_image.url) {
        img.src = resizedImage(item.featured_image.url, '180x');
        img.alt = item.featured_image.alt || item.product_title || item.title || '';
      } else if (item.image) {
        img.src = resizedImage(item.image, '180x');
        img.alt = item.product_title || item.title || '';
      }
      img.loading = 'lazy';
      img.decoding = 'async';

      var title = node.querySelector('.custom-cart__item-title');
      title.href = item.url || '#';
      title.textContent = item.product_title || item.title || '';

      var propsEl = node.querySelector('.custom-cart__item-props');
      propsEl.innerHTML = '';
      if (item.options_with_values && item.options_with_values.length) {
        item.options_with_values.forEach(function (o) {
          if (!o || !o.name || !o.value) return;
          if (String(o.value).toLowerCase() === 'default title') return;
          var d = document.createElement('div');
          d.textContent = o.name + ': ' + o.value;
          propsEl.appendChild(d);
        });
      }
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          var v = item.properties[k];
          if (!k || !v) return;
          if (k.charAt(0) === '_') return;
          var d = document.createElement('div');
          if (typeof v === 'string' && v.indexOf('/uploads/') > -1) {
            var a = document.createElement('a');
            a.href = v;
            a.textContent = v.split('/').pop();
            d.appendChild(document.createTextNode(k + ': '));
            d.appendChild(a);
          } else {
            d.textContent = k + ': ' + v;
          }
          propsEl.appendChild(d);
        });
      }

      var qtyInput = node.querySelector('[data-custom-cart-qty-input]');
      qtyInput.value = item.quantity;
      if (lineKey) {
        qtyInput.setAttribute('data-key', lineKey);
      } else {
        qtyInput.removeAttribute('data-key');
      }

      var priceFinal = node.querySelector('.custom-cart__item-price-final');
      priceFinal.innerHTML = money(item.final_price);
    }

    function patchCartItemRows(cart, itemRows) {
      var items = cart.items || [];
      var i;
      for (i = 0; i < items.length; i++) {
        itemRows[i].item = items[i];
        populateCartItemNode(itemRows[i].node, items[i]);
      }
    }

    function buildCartItemRows(cart) {
      var itemRows = [];
      var fragment = document.createDocumentFragment();
      (cart.items || []).forEach(function (item) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        populateCartItemNode(node, item);
        itemRows.push({ item: item, node: node });
        fragment.appendChild(node);
      });
      elItems.innerHTML = '';
      elItems.appendChild(fragment);
      return itemRows;
    }

    function scheduleRecommendationsForCart(cart) {
      var nonProtectionItems = (cart.items || []).filter(function (i) {
        return !isProtectionCartLine(i);
      });
      var seedProductId = nonProtectionItems[0] && nonProtectionItems[0].product_id;
      if (!seedProductId || seedProductId === lastRecommendedFor) return;
      var loadToken = ++recommendationsLoadToken;
      scheduleDeferred(function () {
        if (loadToken !== recommendationsLoadToken) return;
        if (!drawer.classList.contains('is-open')) return;
        loadRecommendations(seedProductId, cart.items);
      });
    }

    function finalizeCartRender(cart, itemRows, renderGen, opts) {
      opts = opts || {};
      var protAfterRender = getProtectionLineInfo(cart);
      var needsAsyncPrice = protectionPendingIntent && !protAfterRender.inCart
        && syncProtectionUnitCentsFromCache() <= 0 && protectionVariantId;

      function afterTotals() {
        if (!opts.skipRecommendations) {
          scheduleRecommendationsForCart(cart);
        }
        updateDiscountTags(cart);
        updateShippingBar(cart);
        window.requestAnimationFrame(stripInjectedLineDiscounts);
      }

      if (needsAsyncPrice) {
        return resolvePendingProtectionUnitCents().then(function () {
          if (renderGen != null && renderGen !== refreshGeneration) return;
          updateCartTotalsDisplaySync(cart, itemRows);
          updateProtectionUI(protAfterRender.inCart, protAfterRender.unitCents);
          afterTotals();
        });
      }

      updateCartTotalsDisplaySync(cart, itemRows);
      updateProtectionUI(protAfterRender.inCart, protAfterRender.unitCents);
      afterTotals();
      return Promise.resolve();
    }

    function prefetchMissingVariantComparePrices(cart, itemRows, prefetchIds, renderGen) {
      var uncachedIds = getUncachedVariantIds(prefetchIds);
      if (!uncachedIds.length) return;
      prefetchVariantIdsBatched(uncachedIds, 6).then(function () {
        if (renderGen != null && renderGen !== refreshGeneration) return;
        reapplyComparePrices(cart, itemRows);
      });
    }

    function compareCentsFromCartLine(item) {
      var finalP = cents(item.final_price);
      var cap = cents(item.compare_at_price);
      if (cap > finalP) return cap;
      var orig = cents(item.original_price);
      if (orig > finalP) return orig;
      return 0;
    }

    function compareCentsWithVariant(item, variant) {
      var finalP = cents(item.final_price);
      var c = compareCentsFromCartLine(item);
      if (variant && variant.compare_at_price != null) {
        var vc = cents(variant.compare_at_price);
        if (vc > finalP) c = Math.max(c, vc);
      }
      return c;
    }

    function applyLineCompare(node, compareCents, finalCents) {
      var priceCompare = node.querySelector('.custom-cart__item-price-compare');
      var priceFinal = node.querySelector('.custom-cart__item-price-final');
      if (!priceCompare || !priceFinal) return;
      if (compareCents > finalCents && compareCents > 0) {
        priceCompare.innerHTML = money(compareCents);
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }

    function updateSubtotalStrikethroughFromRows(cart, itemRows, displaySubtotalCents) {
      if (!elOriginal) return;
      var displaySubtotal = displaySubtotalCents != null
        ? displaySubtotalCents
        : computeSubtotalDisplayCentsSync(cart);
      var originalSum = computeCompareSubtotalForDisplay(cart, itemRows);
      if (originalSum > displaySubtotal) {
        elOriginal.innerHTML = money(originalSum);
        elOriginal.hidden = false;
      } else {
        elOriginal.hidden = true;
      }
    }

    function updateDiscountRowDisplay(cart, itemRows, displaySubtotalCents) {
      if (!elDiscount || !elDiscountRow) return;
      var compareSub = computeCompareSubtotalForDisplay(cart, itemRows);
      var totalC = displaySubtotalCents != null ? displaySubtotalCents : computeSubtotalDisplayCentsSync(cart);
      var fromCompare = compareSub > totalC ? compareSub - totalC : 0;
      if (fromCompare > 0) {
        elDiscount.innerHTML = '- ' + money(fromCompare);
        elDiscountRow.hidden = false;
        return;
      }
      var codeDiscount = discountAmountCents(cart);
      if (codeDiscount > 0) {
        elDiscount.innerHTML = '- ' + money(codeDiscount);
        elDiscountRow.hidden = false;
      } else {
        elDiscountRow.hidden = true;
      }
    }

    function computeCompareSubtotalCentsFromRows(cart, itemRows) {
      var originalSum = 0;
      itemRows.forEach(function (row) {
        var i = row.item;
        if (isProtectionCartLine(i) && !protectionPendingIntent) return;
        var v = variantCache[i.variant_id];
        var finalP = cents(i.final_price);
        var c = compareCentsWithVariant(i, v);
        if (c > finalP) originalSum += c * i.quantity;
        else originalSum += finalP * i.quantity;
      });
      return originalSum;
    }

    function reapplyComparePrices(cart, itemRows) {
      itemRows.forEach(function (row) {
        var finalP = cents(row.item.final_price);
        var v = variantCache[row.item.variant_id];
        var c = compareCentsWithVariant(row.item, v);
        applyLineCompare(row.node, c, finalP);
      });
      updateCartTotalsDisplaySync(cart, itemRows);
    }

    function isCartPayload(data) {
      if (!data || typeof data !== 'object') return false;
      if (Array.isArray(data.items)) return true;
      if (data.item_count != null) return true;
      if (typeof data.token === 'string' && data.token.length) return true;
      return typeof data.total_price !== 'undefined' && typeof data.cart_level_discount_applications !== 'undefined';
    }

    function discountApplySucceeded(cart, typedCode) {
      return discountCodeIsApplicable(cart, typedCode);
    }

    function fetchFreshCartPayload() {
      return fetchCartJSON(true).catch(function () {
        return null;
      });
    }

    function fetchFreshCartForDiscount(code, attemptsLeft) {
      return fetchCartJSON(true).then(function (cart) {
        if (!cart || !isCartPayload(cart)) return cart;
        if (discountApplySucceeded(cart, code)) return cart;
        if (attemptsLeft <= 1) return cart;
        return waitMs(200).then(function () {
          return fetchFreshCartForDiscount(code, attemptsLeft - 1);
        });
      }).catch(function () {
        return null;
      });
    }

    function syncHeaderCartCount(count) {
      document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
        el.textContent = count;
      });
      document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
        if (count > 0) {
          el.classList.add('cart-link__bubble--visible');
        } else {
          el.classList.remove('cart-link__bubble--visible');
        }
      });
    }

    function syncHeaderCartCountFromServer() {
      return fetchJSON(cartUrl)
        .then(function (cart) {
          if (cart && isCartPayload(cart)) {
            syncHeaderCartCount(cart.item_count);
          }
        })
        .catch(function () {});
    }

    function scheduleHeaderCountResyncAfterCheckoutReturn() {
      syncHeaderCartCountFromServer();
      window.setTimeout(syncHeaderCartCountFromServer, 120);
      window.setTimeout(syncHeaderCartCountFromServer, 400);
    }

    function render(cart, renderGen, opts) {
      opts = opts || {};
      if (!cart) return Promise.resolve();
      if (renderGen != null && renderGen !== refreshGeneration) {
        return Promise.resolve();
      }

      lastRenderedCart = cart;
      elCount.textContent = cart.item_count;
      syncHeaderCartCount(cart.item_count);
      syncNote(cart.note);

      if (!cart.items || cart.items.length === 0) {
        elItems.innerHTML = '';
        elEmpty.hidden = false;
        setCartEmptyState(true);
        if (elDiscountWrap) elDiscountWrap.hidden = true;
        if (elNoteWrap) elNoteWrap.hidden = true;
        elSubtotal.innerHTML = money(0);
        elOriginal.hidden = true;
        elDiscountRow.hidden = true;
        if (elCheckout) elCheckout.disabled = true;
        updateProtectionUI(false, 0, true);
        lastRenderedItemRows = null;
        if (!opts.skipRecommendations) {
          scheduleDeferred(function () {
            if (!drawer.classList.contains('is-open')) return;
            loadRecommendationsFromCollectionAll();
          });
        }
        updateDiscountTags(cart);
        updateShippingBar(cart);
        return Promise.resolve();
      }

      if (elNoteWrap) elNoteWrap.hidden = false;
      if (elDiscountWrap) elDiscountWrap.hidden = false;
      elEmpty.hidden = true;
      setCartEmptyState(false);
      if (elCheckout) elCheckout.disabled = false;

      var protInfo = getProtectionLineInfo(cart);
      updateProtectionUI(protInfo.inCart, protInfo.unitCents);

      if (opts.allowPatch !== false && canPatchCartItems(cart, lastRenderedItemRows)) {
        patchCartItemRows(cart, lastRenderedItemRows);
        return finalizeCartRender(cart, lastRenderedItemRows, renderGen, opts);
      }

      var prefetchIds = [];
      var prefetchSeen = {};
      cart.items.forEach(function (i) {
        var vid = i.variant_id;
        if (vid && !prefetchSeen[vid]) {
          prefetchSeen[vid] = true;
          prefetchIds.push(vid);
        }
      });
      if (protectionVariantId && !prefetchSeen[protectionVariantId]) {
        prefetchSeen[protectionVariantId] = true;
        prefetchIds.push(protectionVariantId);
      }

      var itemRows = buildCartItemRows(cart);
      reapplyComparePrices(cart, itemRows);
      lastRenderedItemRows = itemRows;
      prefetchMissingVariantComparePrices(cart, itemRows, prefetchIds, renderGen);
      return finalizeCartRender(cart, itemRows, renderGen, opts);
    }

    function findLineByKey(cart, key) {
      var items = (cart && cart.items) || [];
      for (var li = 0; li < items.length; li++) {
        if (items[li].key === key) return items[li];
      }
      return null;
    }

    function updateProtectionUI(isInCart, priceCents, cartEmpty) {
      if (!elProtectionWrap) {
        return;
      }
      if (cartEmpty || !isProtectionConfigured()) {
        elProtectionWrap.hidden = true;
        return;
      }
      elProtectionWrap.hidden = false;
      elProtectionWrap.removeAttribute('hidden');
      if (elProtectionToggle) {
        elProtectionToggle.checked = protectionPendingIntent;
        elProtectionToggle.disabled = !protectionVariantId && cachedProtectionUnitCents <= 0 && !(protectionProductHandle || '').trim();
      }
      if (elProtectionPrice) {
        if (priceCents > 0) {
          elProtectionPrice.textContent = moneyPlain(priceCents);
        } else if (cachedProtectionUnitCents > 0) {
          elProtectionPrice.textContent = moneyPlain(cachedProtectionUnitCents);
        } else if (isProtectionConfigured() && ((protectionProductHandle || '').trim() || protectionProductId)) {
          resolveProtectionConfig();
        } else if (protectionVariantId) {
          syncProtectionUnitCentsFromCache();
          if (cachedProtectionUnitCents > 0) {
            elProtectionPrice.textContent = moneyPlain(cachedProtectionUnitCents);
          } else {
            fetchVariantCached(protectionVariantId).then(function (v) {
              rememberProtectionVariantPrices(v);
              if (cachedProtectionUnitCents > 0 && elProtectionPrice) {
                elProtectionPrice.textContent = moneyPlain(cachedProtectionUnitCents);
              }
              if (lastRenderedCart) {
                updateCartTotalsDisplaySync(lastRenderedCart, lastRenderedItemRows);
              }
            });
          }
        }
      }
      if (lastRenderedCart && !cartEmpty) {
        updateCartTotalsDisplaySync(lastRenderedCart, lastRenderedItemRows);
      }
    }

    function toggleProtection(enable) {
      protectionPendingIntent = enable;
      persistProtectionPendingIntent(enable);
      if (elProtectionToggle) elProtectionToggle.checked = enable;
      if (lastRenderedCart) {
        updateCartTotalsDisplaySync(lastRenderedCart, lastRenderedItemRows);
      }
      if (!enable && isProtectionConfigured() && lastRenderedCart) {
        var prot = getProtectionLineInfo(lastRenderedCart);
        if (prot.inCart) {
          removeProtectionLinesFromCart()
            .then(function () { return refresh({ skipLoading: true }); })
            .catch(function () { return refresh({ skipLoading: true }); });
        }
      }
    }

    function setNoteCheckoutHintVisible(visible) {
      if (!elNoteCheckoutHint) return;
      elNoteCheckoutHint.hidden = !visible;
    }

    function syncNote(note) {
      if (!elNoteInput || !elNoteToggle) return;
      if (note && String(note).trim()) {
        elNoteInput.value = note;
        elNoteInput.hidden = false;
        elNoteToggle.textContent = noteCloseLabel;
        elNoteToggle.setAttribute('aria-expanded', 'true');
        setNoteCheckoutHintVisible(true);
      } else {
        if (document.activeElement === elNoteInput) return;
        elNoteInput.value = '';
        elNoteInput.hidden = true;
        elNoteToggle.textContent = noteOpenLabel;
        elNoteToggle.setAttribute('aria-expanded', 'false');
        setNoteCheckoutHintVisible(false);
      }
    }

    function toggleNote() {
      if (!elNoteInput) return;
      var isOpen = !elNoteInput.hidden;
      if (isOpen) {
        elNoteInput.hidden = true;
        elNoteToggle.textContent = noteOpenLabel;
        elNoteToggle.setAttribute('aria-expanded', 'false');
        setNoteCheckoutHintVisible(false);
      } else {
        elNoteInput.hidden = false;
        elNoteToggle.textContent = noteCloseLabel;
        elNoteToggle.setAttribute('aria-expanded', 'true');
        setNoteCheckoutHintVisible(true);
        elNoteInput.focus();
      }
    }

    function buildCartChangeBody(key, qty, itemEl) {
      var k = key != null ? String(key).trim() : '';
      if (!k && itemEl) {
        var inp = itemEl.querySelector('[data-custom-cart-qty-input]');
        if (inp) k = (inp.getAttribute('data-key') || '').trim();
      }
      if (k) return { id: k, quantity: qty };
      if (itemEl && elItems && elItems.contains(itemEl)) {
        var line = Array.prototype.indexOf.call(elItems.children, itemEl) + 1;
        if (line > 0) return { line: line, quantity: qty };
      }
      return null;
    }

    function findCartLineForClamp(cart, changeBody, keyFallback) {
      if (changeBody && changeBody.id) return findLineByKey(cart, changeBody.id);
      if (changeBody && changeBody.line != null && changeBody.line > 0) {
        var arr = (cart && cart.items) || [];
        return arr[changeBody.line - 1] || null;
      }
      var fk = keyFallback != null ? String(keyFallback).trim() : '';
      if (fk) return findLineByKey(cart, fk);
      return null;
    }

    var updating = false;
    function update(key, qty, itemEl) {
      if (updating) return Promise.resolve();
      if (qty > 0 && qty < MIN_QTY) qty = MIN_QTY;
      var changeBody = buildCartChangeBody(key, qty, itemEl);
      if (!changeBody) {
        return refresh({ skipLoading: true });
      }
      var metaKey = changeBody.id || (key != null ? String(key).trim() : '');
      updating = true;
      if (elLoading) elLoading.hidden = false;
      return fetchJSON(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(changeBody)
      })
        .then(function (cart) {
          return Promise.resolve(render(cart, null, {
            allowPatch: true,
            skipRecommendations: true
          })).then(function () {
            if (qty > 0) {
              var line = findCartLineForClamp(cart, changeBody, key);
              if (line && line.quantity < qty) {
                pendingModalAction = { type: 'clamp', key: line.key || metaKey, qty: line.quantity };
                var body = buildQtyErrorModalText(
                  { data: {} },
                  line.quantity,
                  line.product_title || line.title || ''
                );
                showCartErrorModal(body, qtyStockLimitTitle);
              }
            }
          });
        })
        .catch(function (err) {
          return resolveClampMeta(metaKey).then(function (meta) {
            var blob =
              normalizeErrorDescription(err.data && err.data.description) +
              ' ' +
              normalizeErrorDescription(err.data && err.data.message) +
              ' ' +
              (err.message || '');
            var fromMsg = parseAvailableQtyFromMessage(blob);
            var fromVariant = meta && meta.clamp;
            var lineTitle = (meta && meta.lineTitle) || '';
            var clampQty = null;
            if (fromVariant != null && fromMsg != null) clampQty = Math.min(fromVariant, fromMsg);
            else if (fromVariant != null) clampQty = fromVariant;
            else clampQty = fromMsg;
            pendingModalAction = null;
            if (clampQty != null) {
              pendingModalAction = { type: 'clamp', key: metaKey, qty: clampQty };
            } else {
              pendingModalAction = { type: 'refresh' };
            }
            var body = buildQtyErrorModalText(err, clampQty, lineTitle);
            showCartErrorModal(body, qtyStockLimitTitle);
          })
            .catch(function () {
              showCartErrorModal(buildQtyErrorModalText(err, null, ''), qtyStockLimitTitle);
            });
        })
        .finally(function () {
          updating = false;
          if (elLoading) elLoading.hidden = true;
        });
    }

    function postCartDiscount(body) {
      return fetchJSON(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (data) {
        invalidateCartFetchCache();
        return data;
      });
    }

    function sanitizeCartDiscountState(cart) {
      if (!cart || !cart.discount_codes || !cart.discount_codes.length) {
        return Promise.resolve(cart);
      }
      if (!cartShouldClearDiscountCodes(cart)) {
        return Promise.resolve(cart);
      }
      return postCartDiscount({ discount: '' })
        .then(function () {
          return fetchCartJSON();
        })
        .catch(function () {
          return cart;
        });
    }

    function cartFromUpdateResponse(data) {
      if (!isCartPayload(data)) return fetchCartJSON(true);
      return Promise.resolve(data);
    }

    function applyDiscount(code) {
      var trimmed = (code || '').trim();
      if (!trimmed || applyingDiscount) return;

      beginDiscountApplyUi();
      hideToast();

      var renderGen = ++refreshGeneration;

      function finishSuccess(cart) {
        return fetchFreshCartForDiscount(trimmed, 3).then(function (freshCart) {
          var finalCart = cart;
          if (freshCart && isCartPayload(freshCart) && discountApplySucceeded(freshCart, trimmed)) {
            finalCart = freshCart;
          }
          if (!discountApplySucceeded(finalCart, trimmed)) {
            return finishFailure(finalCart);
          }
          return Promise.resolve(render(finalCart, renderGen)).then(function () {
            updateDiscountTags(finalCart);
            showToast('success', discountAppliedToast);
            if (elDiscountInput) elDiscountInput.value = '';
          });
        });
      }

      function finishFailure(cart) {
        return postCartDiscount({ discount: '' })
          .then(function (data) {
            return cartFromUpdateResponse(data);
          })
          .catch(function () {
            return cart;
          })
          .then(function (clearedCart) {
            var payload = (clearedCart && isCartPayload(clearedCart)) ? clearedCart : cart;
            return fetchFreshCartPayload().then(function (freshCart) {
              var finalCart = (freshCart && isCartPayload(freshCart)) ? freshCart : payload;
              return Promise.resolve(render(finalCart, renderGen)).then(function () {
                updateDiscountTags(finalCart);
                showToast('error', discountInvalidMsg);
              });
            });
          });
      }

      ensureProtectionRemovedForDiscount()
        .then(function () {
          invalidateCartFetchCache();
          return postCartDiscount({ discount: trimmed });
        })
        .then(function (data) {
          return cartFromUpdateResponse(data);
        })
        .then(function (cart) {
          if (discountApplySucceeded(cart, trimmed)) {
            return finishSuccess(cart);
          }
          return fetchFreshCartForDiscount(trimmed, 3).then(function (polledCart) {
            if (polledCart && discountApplySucceeded(polledCart, trimmed)) {
              return finishSuccess(polledCart);
            }
            return finishFailure(polledCart || cart);
          });
        })
        .catch(function () {
          return finishFailure(null);
        })
        .finally(function () {
          resetDiscountApplyUi();
        });
    }

    function buildDiscountValidationContext(cart) {
      if (!cart || !isCartPayload(cart)) {
        return { cart: null, subtotalCents: 0, itemQuantity: 0, cartItems: [] };
      }
      var itemQuantity = 0;
      var cartItems = [];
      (cart.items || []).forEach(function (it) {
        if (isProtectionCartLine(it)) return;
        cartItems.push(it);
        itemQuantity += Number(it.quantity) || 0;
      });
      return {
        cart: cart,
        subtotalCents: cartMerchandiseSubtotalExcludingProtectionCents(cart),
        itemQuantity: itemQuantity,
        cartItems: cartItems
      };
    }

    function getDiscountValidationContext() {
      return ensureProtectionRemovedForDiscount()
        .then(function () {
          return fetchCartJSON(true);
        })
        .then(function (cart) {
          return buildDiscountValidationContext(cart);
        });
    }

    function validateDiscountBeforeApply(code) {
      var verification = window.DiscountVerification;

      return getDiscountValidationContext()
        .then(function (ctx) {
          if (ctx.cart && discountApplySucceeded(ctx.cart, code)) {
            return discountInvalidMsg;
          }
          if (!verification || typeof verification.verify !== 'function') {
            return null;
          }
          var options = typeof verification.buildValidationOptions === 'function'
            ? verification.buildValidationOptions(null, {
              subtotalCents: ctx.subtotalCents,
              itemQuantity: ctx.itemQuantity,
              cartItems: ctx.cartItems,
              invalidMessage: discountInvalidMsg,
              minAmountMessageTemplate: discountMinAmountMsg,
              noEligibleItemsMessage: discountNoEligibleItemsMsg,
              expiredMessage: discountExpiredMsg,
              notStartedMessage: discountNotStartedMsg,
              usageLimitMessage: discountUsageLimitMsg,
              customerLoginRequiredMessage: discountCustomerLoginMsg,
              shippingCountryInvalidMessage: discountShippingCountryMsg
            })
            : {
              subtotalCents: ctx.subtotalCents,
              itemQuantity: ctx.itemQuantity,
              cartItems: ctx.cartItems,
              invalidMessage: discountInvalidMsg,
              minAmountMessageTemplate: discountMinAmountMsg,
              noEligibleItemsMessage: discountNoEligibleItemsMsg,
              expiredMessage: discountExpiredMsg,
              notStartedMessage: discountNotStartedMsg,
              usageLimitMessage: discountUsageLimitMsg,
              customerLoginRequiredMessage: discountCustomerLoginMsg,
              shippingCountryInvalidMessage: discountShippingCountryMsg
            };
          return verification.verify(code, options);
        })
        .then(function (result) {
          if (typeof result === 'string') return result;
          if (!result || result.fallback || result.ok !== false) {
            return null;
          }
          return result.message || discountInvalidMsg;
        })
        .catch(function () {
          return null;
        });
    }

    function handleDiscountApply(evt) {
      if (evt) evt.preventDefault();
      if (applyingDiscount) return;
      var code = elDiscountInput ? (elDiscountInput.value || '').trim() : '';
      if (!code) return;

      beginDiscountApplyUi(15000);

      validateDiscountBeforeApply(code)
        .then(function (errMsg) {
          if (errMsg) {
            resetDiscountApplyUi();
            showToast('error', errMsg);
            return;
          }
          resetDiscountApplyUi();
          applyDiscount(code);
        })
        .catch(function () {
          resetDiscountApplyUi();
          showToast('error', discountInvalidMsg);
        });
    }

    function saveNote(text) {
      return fetchJSON(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: text || '' })
      }).catch(function () {
        if (noteSaveFailedMsg) showToast('error', noteSaveFailedMsg);
      });
    }

    function loadRecommendationsFromCollectionAll() {
      lastRecommendedFor = '__collection_all__';
      return fetchJSON('/collections/all/products.json?limit=' + REC_LIMIT)
        .then(function (data) {
          var products = (data && data.products) || [];
          if (!products.length) {
            elRecommendations.hidden = true;
            elRecommendationsList.innerHTML = '';
            return;
          }
          renderRecommendations(products);
        })
        .catch(function () {
          elRecommendations.hidden = true;
          elRecommendationsList.innerHTML = '';
        });
    }

    function loadRecommendations(productId, currentItems) {
      lastRecommendedFor = productId;
      var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + REC_LIMIT + '&intent=related';
      var inCartIds = (currentItems || []).map(function (i) { return i.product_id; });

      fetchJSON(url)
        .then(function (data) {
          var products = (data && data.products) || [];
          products = products.filter(function (p) { return inCartIds.indexOf(p.id) === -1; });
          renderRecommendations(products);
        })
        .catch(function () {
          elRecommendations.hidden = true;
        });
    }

    function renderRecommendations(products) {
      elRecommendationsList.innerHTML = '';
      if (!products || products.length === 0 || !recTpl) {
        elRecommendations.hidden = true;
        return;
      }
      elRecommendations.hidden = false;
      var fragment = document.createDocumentFragment();
      products.forEach(function (p) {
        var node = recTpl.content.firstElementChild.cloneNode(true);
        node.dataset.productId = p.id;
        node.dataset.productHandle = p.handle || '';

        var imgWrap = node.querySelector('.custom-cart__rec-image');
        var img = node.querySelector('.custom-cart__rec-image img');
        imgWrap.href = p.url || ('/products/' + p.handle);
        var imgUrl = p.featured_image || (p.images && p.images[0]) || '';
        if (typeof imgUrl === 'object' && imgUrl) imgUrl = imgUrl.src || imgUrl.url || '';
        if (imgUrl) {
          img.src = resizedImage(imgUrl, '180x');
          img.alt = p.title || '';
          img.loading = 'lazy';
          img.decoding = 'async';
        }

        var titleEl = node.querySelector('.custom-cart__rec-title');
        titleEl.href = p.url || ('/products/' + p.handle);
        titleEl.textContent = p.title || '';

        var priceFinal = node.querySelector('.custom-cart__rec-price-final');
        var priceCompare = node.querySelector('.custom-cart__rec-price-compare');
        var priceCents = recProductPriceCents(p);
        priceFinal.innerHTML = money(priceCents);

        var compareCents = recProductCompareCents(p);
        if (compareCents && compareCents > priceCents) {
          priceCompare.innerHTML = money(compareCents);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }

        var addBtn = node.querySelector('[data-custom-cart-rec-add]');
        if (p.available === false) {
          addBtn.textContent = soldOutLabel || addBtn.textContent;
          addBtn.disabled = true;
        }

        fragment.appendChild(node);
      });
      elRecommendationsList.appendChild(fragment);
    }

    function unloadQuickShopProductInstances(productId, handle) {
      if (!window.theme || !window.theme.sections || !Array.isArray(window.theme.sections.instances)) return;
      var sid = String(productId);
      var h = String(handle || '').trim();
      for (var i = window.theme.sections.instances.length - 1; i >= 0; i--) {
        var inst = window.theme.sections.instances[i];
        if (!inst || inst.type !== 'product' || !inst.container) continue;
        var pid = inst.productId || inst.container.getAttribute('data-product-id');
        var ph = inst.container.getAttribute('data-product-handle') || '';
        var inQuickShop =
          typeof inst.container.closest === 'function' &&
          (inst.container.closest('#QuickShopHolder') ||
            inst.container.closest('.js-cart-rec-quickshop-root'));
        if (inQuickShop && (pid === sid || ph === h)) {
          if (typeof inst.onUnload === 'function') {
            inst.onUnload();
          }
          window.theme.sections.instances.splice(i, 1);
        }
      }
    }

    function preloadQuickShopBlocks(sectionEl) {
      if (!sectionEl) return Promise.resolve();
      var blocksHolder = sectionEl.querySelector('[data-blocks-holder]');
      if (!blocksHolder) return Promise.resolve();
      if (blocksHolder.classList.contains('product-form-holder--loaded')) {
        return Promise.resolve();
      }
      var url = blocksHolder.getAttribute('data-url') || blocksHolder.dataset.url;
      if (!url) return Promise.resolve();

      return fetch(url, { credentials: 'same-origin', mode: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var blocks = doc.querySelector('[data-product-blocks]');
          if (!blocks) return;

          blocks.querySelectorAll('[id]').forEach(function (el) {
            var val = el.getAttribute('id');
            if (!val) return;
            el.setAttribute('id', val + '-modal');
            var label = blocks.querySelector('[for="' + val + '"]');
            if (label) label.setAttribute('for', val + '-modal');
            var collapsibleTrigger = blocks.querySelector('[aria-controls="' + val + '"]');
            if (collapsibleTrigger) {
              collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
            }
          });

          var form = blocks.querySelector('.product-single__form');
          if (form) {
            var formId = form.getAttribute('id');
            blocks.querySelectorAll('[form]').forEach(function (el) {
              el.setAttribute('form', formId);
            });
          }

          blocksHolder.innerHTML = '';
          blocksHolder.appendChild(blocks);
          blocksHolder.classList.add('product-form-holder--loaded');
        });
    }

    function revealQuickShopMedia(scope) {
      if (!scope) return;
      var root = (scope.closest && scope.closest('.modal--quick-shop')) || scope;
      root.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.setAttribute('loading', 'eager');
      });
      root.querySelectorAll('[data-aos]').forEach(function (el) {
        el.classList.add('aos-animate');
      });
      root.querySelectorAll('image-element').forEach(function (el) {
        el.classList.add('aos-animate');
      });
    }

    function syncQuickShopVariantUi(instance) {
      if (!instance || !instance.container || !instance.variants) return;
      var v = instance.variants.currentVariant;
      var ms = instance.container.querySelector(instance.selectors.originalSelectorId);
      if (ms && v) {
        ms.value = String(v.id);
      }
      instance.container.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            variant: v,
            currentlySelectedValues: instance.variants.currentlySelectedValues
          }
        })
      );
    }

    function initQuickShopProductInstance(holder) {
      if (!holder || !window.theme || !window.theme.sections) return null;
      var section = holder.querySelector('.product-section[data-section-type="product"]');
      if (!section) return null;

      window.theme.sections.register('product', window.theme.Product, holder);
      var sectionId = section.getAttribute('data-section-id');
      var instance = window.theme.sections._findInstance(sectionId);
      if (!instance) return null;

      instance.settings.modalInit = true;
      instance.cacheElements();
      instance.formSetup();
      instance.updateModalProductInventory();
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
      instance.productSetup();
      instance.videoSetup();
      instance.initProductSlider();
      instance.customMediaListners();
      window.theme.collapsibles.init(instance.container);
      if (typeof window.theme.bindVariantErrorClear === 'function') {
        window.theme.bindVariantErrorClear(instance.container);
      }
      if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
        if (typeof window.theme.clearDefaultVariantSelection === 'function') {
          window.theme.clearDefaultVariantSelection(instance.container);
        }
      }
      if (typeof window.theme.videoModal === 'function') {
        window.theme.videoModal();
      }
      if (window.AOS && typeof window.AOS.refreshHard === 'function') {
        window.AOS.refreshHard();
      }
      revealQuickShopMedia(holder);
      syncQuickShopVariantUi(instance);
      document.dispatchEvent(
        new CustomEvent('quickview:open', {
          detail: {
            initialized: true,
            productId: instance.productId
          }
        })
      );
      return instance;
    }

    function destroyCartRecQuickShopRoot() {
      document.querySelectorAll('.js-cart-rec-quickshop-root').forEach(function (root) {
        if (window.theme && window.theme.sections && Array.isArray(window.theme.sections.instances)) {
          for (var i = window.theme.sections.instances.length - 1; i >= 0; i--) {
            var inst = window.theme.sections.instances[i];
            if (
              inst &&
              inst.container &&
              typeof inst.container.closest === 'function' &&
              inst.container.closest('.js-cart-rec-quickshop-root') === root
            ) {
              if (typeof inst.onUnload === 'function') {
                inst.onUnload();
              }
              window.theme.sections.instances.splice(i, 1);
            }
          }
        }
        if (root.parentNode) root.parentNode.removeChild(root);
      });
    }

    function canUseThemeQuickShopForRec() {
      var t = window.theme;
      if (!t || !t.settings || !t.settings.quickView) return false;
      if (!t.QuickShopModal || typeof t.QuickShopModal.open !== 'function') return false;
      if (typeof t.preloadProductModal !== 'function') return false;
      return true;
    }

    function openCartRecThemeQuickShop(handle, productId) {
      if (!handle || !productId) return Promise.resolve();
      destroyCartRecQuickShopRoot();
      if (window.theme && window.theme.QuickShopModal && typeof window.theme.QuickShopModal.open === 'function') {
        return window.theme.QuickShopModal.open(handle, productId);
      }
      return Promise.reject(new Error('Quick shop unavailable'));
    }

    function onRecAdd(handle, btn) {
      if (!handle) return;
      btn.disabled = true;
      fetchJSON('/products/' + handle + '.js')
        .then(function (product) {
          var availableVariants = (product.variants || []).filter(function (v) { return v.available; });
          var hasOptions = product.options && product.options.length &&
            !(product.options.length === 1 && (product.options[0] === 'Title' || (product.options[0].name === 'Title')));
          if (!hasOptions || availableVariants.length === 1) {
            var variant = availableVariants[0] || product.variants[0];
            return addToCart(variant.id, 1, {
              showSuccessToast: true,
              productTitle: product.title || ''
            });
          }
          if (canUseThemeQuickShopForRec()) {
            return openCartRecThemeQuickShop(handle, product.id).catch(function () {
              openQuickAdd(product);
            });
          }
          openQuickAdd(product);
        })
        .finally(function () {
          btn.disabled = false;
        })
        .catch(function () {});
    }

    function showCartAddSuccessToast(productTitle) {
      if (window.theme && window.theme.CartToast && typeof window.theme.CartToast.show === 'function') {
        window.theme.CartToast.show(productTitle || '');
        return;
      }
      var title = String(productTitle || '').trim();
      if (title) {
        showToast('success', title + ' successfully added to cart!');
      }
    }

    function addToCart(variantId, quantity, options) {
      options = options || {};
      return fetchJSON(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function () {
          invalidateCartFetchCache();
          if (options.showSuccessToast) {
            showCartAddSuccessToast(options.productTitle);
          }
          closeThemeCartDrawerIfOpen();
          return refresh({
            skipLoading: true,
            forceFresh: true,
            allowPatch: false
          });
        })
        .catch(function (err) {
          if (isLikelyNetworkError(err)) {
            var netTitle = String(addNetworkErrorTitle || '').trim();
            var netBody = String(addNetworkErrorBody || '').trim() || netTitle;
            if (!netBody) netBody = (err && err.message) || 'Error';
            showCartErrorModal(netBody, netTitle);
          } else {
            showCartErrorModal((err && err.message) || 'Error', '');
          }
          return Promise.reject(err);
        });
    }

    function openQuickAdd(product) {
      currentQuickAddProduct = product;
      currentQuickAddVariant = null;

      var imageUrl = '';
      if (product.featured_image) imageUrl = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src || product.featured_image.url;
      else if (product.images && product.images[0]) imageUrl = product.images[0];
      elQAImage.src = imageUrl ? resizedImage(imageUrl, '180x') : '';
      elQAImage.alt = product.title || '';
      if (elQAImageLink) elQAImageLink.href = product.url || ('/products/' + product.handle);

      elQATitle.textContent = product.title || '';
      elQAMeta.textContent = '';

      var options = product.options || [];
      var normalizedOptions = options.map(function (o, i) {
        if (typeof o === 'string') return { name: o, position: i + 1, values: [] };
        return { name: o.name, position: o.position || (i + 1), values: o.values || [] };
      });

      elQAOptions.innerHTML = '';
      normalizedOptions.forEach(function (opt, idx) {
        var values = opt.values && opt.values.length ? opt.values : uniqueOptionValues(product.variants, idx);
        var wrap = document.createElement('div');
        var label = document.createElement('label');
        label.className = 'custom-cart__quick-add-option-label';
        label.textContent = opt.name;
        var select = document.createElement('select');
        select.className = 'custom-cart__quick-add-option-select';
        select.dataset.optionIndex = idx;
        values.forEach(function (val) {
          var op = document.createElement('option');
          op.value = val;
          op.textContent = val;
          select.appendChild(op);
        });
        wrap.appendChild(label);
        wrap.appendChild(select);
        elQAOptions.appendChild(wrap);
      });

      updateQuickAddVariant();
      elQuickAdd.hidden = false;
    }

    function uniqueOptionValues(variants, optionIndex) {
      var key = 'option' + (optionIndex + 1);
      var seen = {};
      var out = [];
      (variants || []).forEach(function (v) {
        var val = v[key];
        if (val && !seen[val]) {
          seen[val] = true;
          out.push(val);
        }
      });
      return out;
    }

    function updateQuickAddVariant() {
      if (!currentQuickAddProduct) return;
      var selects = elQAOptions.querySelectorAll('select');
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });

      var variant = (currentQuickAddProduct.variants || []).find(function (v) {
        return chosen.every(function (val, i) {
          var key = 'option' + (i + 1);
          return v[key] === val;
        });
      });

      currentQuickAddVariant = variant || null;

      if (variant) {
        elQAPriceFinal.innerHTML = money(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          elQAPriceCompare.innerHTML = money(variant.compare_at_price);
          elQAPriceCompare.hidden = false;
        } else {
          elQAPriceCompare.hidden = true;
        }
        elQAMeta.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
        if (variant.available) {
          elQASubmit.disabled = false;
          elQASubmit.textContent = addToCartLabel;
        } else {
          elQASubmit.disabled = true;
          elQASubmit.textContent = soldOutLabel || addToCartLabel;
        }
      } else {
        elQASubmit.disabled = true;
        elQASubmit.textContent = soldOutLabel || addToCartLabel;
      }
    }

    function closeQuickAdd() {
      if (!elQuickAdd) return;
      elQuickAdd.hidden = true;
      currentQuickAddProduct = null;
      currentQuickAddVariant = null;
    }

    function submitQuickAdd() {
      if (!currentQuickAddVariant || !currentQuickAddVariant.available) return;
      elQASubmit.disabled = true;
      addToCart(currentQuickAddVariant.id, 1)
        .then(function () {
          closeQuickAdd();
        })
        .catch(function () {})
        .finally(function () {
          elQASubmit.disabled = false;
        });
    }

    function syncProtectionInCartForCheckout() {
      if (!protectionVariantId) return Promise.resolve();
      return fetchCartJSON().then(function (cart) {
        var protInCart = false;
        var protLineKey = null;
        (cart.items || []).forEach(function (item) {
          if (isProtectionCartLine(item)) {
            protInCart = true;
            protLineKey = item.key;
          }
        });

        if (protectionPendingIntent && !protInCart) {
          return fetchJSON(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: protectionVariantId, quantity: 1 })
          });
        }
        if (!protectionPendingIntent && protInCart && protLineKey) {
          return fetchJSON(changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(protLineKey), quantity: 0 })
          });
        }
        return Promise.resolve();
      });
    }

    function handleCheckout() {
      if (elCheckout) elCheckout.disabled = true;
      markCheckoutReturnStrip();

      var prep = protectionVariantId ? syncProtectionInCartForCheckout() : Promise.resolve();
      prep
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.location.href = '/checkout';
        });
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-custom-cart-discount-remove]')) {
        e.preventDefault();
        if (removingDiscount || applyingDiscount) return;
        removeCartDiscountCodes().then(function (ok) {
          if (ok) {
            showToast('success', discountRemovedToast);
            return;
          }
          return refresh({ skipLoading: true }).then(function () {
            showToast('error', discountInvalidMsg);
          });
        });
        return;
      }
      if (e.target.closest('[data-custom-cart-modal-ok]')) {
        e.preventDefault();
        var action = pendingModalAction;
        pendingModalAction = null;
        hideModal();
        if (action && action.type === 'clamp') {
          update(action.key, action.qty).then(function () {
            return refresh({ skipLoading: true });
          }).catch(function () {
            return refresh({ skipLoading: true });
          });
        } else if (action && action.type === 'refresh') {
          refresh({ skipLoading: true });
        }
        return;
      }
      if (e.target.closest('[data-custom-cart-quick-add-close]')) {
        e.preventDefault();
        closeQuickAdd();
        return;
      }
      if (e.target.closest('[data-custom-cart-quick-add-submit]')) {
        e.preventDefault();
        submitQuickAdd();
        return;
      }
      if (e.target.closest('[data-custom-cart-banner]')) {
        e.preventDefault();
        handleBannerClick();
        return;
      }
      if (e.target.closest('[data-custom-cart-close]')) {
        e.preventDefault();
        close();
        return;
      }
      if (e.target.closest('[data-custom-cart-note-toggle]')) {
        e.preventDefault();
        toggleNote();
        return;
      }
      var recAddBtn = e.target.closest('[data-custom-cart-rec-add]');
      if (recAddBtn) {
        e.preventDefault();
        var recEl = recAddBtn.closest('.custom-cart__rec');
        if (recEl) onRecAdd(recEl.dataset.productHandle, recAddBtn);
        return;
      }
      var minus = e.target.closest('[data-custom-cart-qty-minus]');
      var plus = e.target.closest('[data-custom-cart-qty-plus]');
      var remove = e.target.closest('[data-custom-cart-remove]');
      var itemEl = e.target.closest('.custom-cart__item');

      if ((minus || plus) && itemEl) {
        var input = itemEl.querySelector('[data-custom-cart-qty-input]');
        var cur = parseInt(input.value, 10) || MIN_QTY;
        if (cur < MIN_QTY) cur = MIN_QTY;
        var next = plus ? cur + 1 : Math.max(MIN_QTY, cur - 1);
        if (next > MAX_QTY) next = MAX_QTY;
        if (next === cur) return;
        update(itemEl.dataset.key, next, itemEl);
        return;
      }
      if (remove && itemEl) {
        update(itemEl.dataset.key, 0, itemEl);
        return;
      }
      if (e.target.closest('[data-custom-cart-checkout]')) {
        e.preventDefault();
        handleCheckout();
      }
    });

    drawer.addEventListener('keydown', function (e) {
      if (!e.target.closest('[data-custom-cart-banner]')) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      handleBannerClick();
    });

    drawer.addEventListener('input', function (e) {
      var input = e.target.closest('[data-custom-cart-qty-input]');
      if (!input) return;
      var n = parseInt(input.value, 10);
      if (!isNaN(n) && n > MAX_QTY) input.value = MAX_QTY;
    });

    drawer.addEventListener('change', function (e) {
      if (e.target === elProtectionToggle) {
        toggleProtection(elProtectionToggle.checked);
        return;
      }
      var input = e.target.closest('[data-custom-cart-qty-input]');
      if (input) {
        var itemEl = e.target.closest('.custom-cart__item');
        if (!itemEl) return;
        var n = parseInt(input.value, 10);
        if (isNaN(n) || n < MIN_QTY) n = MIN_QTY;
        if (n > MAX_QTY) n = MAX_QTY;
        input.value = n;
        update(itemEl.dataset.key, n, itemEl);
        return;
      }
      var optSelect = e.target.closest('.custom-cart__quick-add-option-select');
      if (optSelect) {
        updateQuickAddVariant();
      }
    });

    if (elDiscountForm) {
      elDiscountForm.addEventListener('submit', handleDiscountApply);
    }

    if (elDiscountApply) {
      elDiscountApply.addEventListener('click', function (e) {
        if (applyingDiscount) {
          e.preventDefault();
        }
      });
    }

    if (elDiscountInput) {
      elDiscountInput.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        handleDiscountApply(e);
      });
    }

    if (elNoteInput) {
      var noteTimer = null;
      elNoteInput.addEventListener('blur', function () {
        saveNote(elNoteInput.value);
      });
      elNoteInput.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () { saveNote(elNoteInput.value); }, 800);
      });
    }

    document.addEventListener('quickview:loaded', function (evt) {
      var t = window.theme;
      if (!t || !evt.detail || !evt.detail.productId) return;
      var modal = typeof t.getQuickShopModal === 'function'
        ? t.getQuickShopModal()
        : document.getElementById('QuickShopModal');
      if (!modal) return;
      var section = modal.querySelector('.product-section');
      if (!section) return;
      if (typeof t.applyQuickShopVariantDefaults === 'function') {
        t.applyQuickShopVariantDefaults(section);
      }
      if (t.sections && typeof t.sections._findInstance === 'function') {
        var inst = t.sections._findInstance(section.getAttribute('data-section-id'));
        if (inst) {
          if (typeof t.syncQuickShopVariantState === 'function') {
            t.syncQuickShopVariantState(inst);
          } else if (typeof t.resetQuickShopAddToCartButton === 'function') {
            t.resetQuickShopAddToCartButton(inst);
          }
        }
      }
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-custom-cart-open]');
      if (trigger) {
        e.preventDefault();
        lastCartOpenTrigger = trigger;
        open();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        if (elToast && !elToast.hidden) {
          hideToast();
        } else if (elModal && !elModal.hidden) {
          pendingModalAction = null;
          hideModal();
        } else if (elQuickAdd && !elQuickAdd.hidden) closeQuickAdd();
        else close();
      }
    });

    window.addEventListener('pageshow', function () {
      var needStrip = false;
      try {
        needStrip = window.sessionStorage.getItem(SS_PROT_CHECKOUT_RETURN) === '1';
        if (needStrip) window.sessionStorage.removeItem(SS_PROT_CHECKOUT_RETURN);
      } catch (ePage) {
        return;
      }
      if (!needStrip) return;
      removeProtectionLinesFromCart()
        .then(function () {
          return refresh({ skipLoading: true });
        })
        .catch(function () {
          return refresh({ skipLoading: true });
        })
        .finally(function () {
          scheduleHeaderCountResyncAfterCheckoutReturn();
        });
    });

    function refreshCustomCartAfterExternalAdd(evt) {
      if (!drawer.classList.contains('is-open')) return;
      var cart = evt && evt.detail && evt.detail.cart;
      if (cart) {
        invalidateCartFetchCache();
        render(cart, refreshGeneration, {
          allowPatch: false,
          skipRecommendations: false
        });
        return;
      }
      refresh({ skipLoading: true, forceFresh: true, allowPatch: false });
    }

    document.addEventListener('ajaxProduct:added', refreshCustomCartAfterExternalAdd);
    document.addEventListener('cart:updated', refreshCustomCartAfterExternalAdd);

    window.CustomCart = {
      open: open,
      close: close,
      refresh: refresh
    };

    scheduleDeferred(function () {
      fetchCartJSON().catch(function () {});
    });
  });
})();
